import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type CreditAnalyticsParams, type OpenCreditPackModalLocations } from '../types';
import META from './useTrackCreditPackCancellationInitiated.meta';

export type UseTrackCreditPackCancellationInitiatedParams = CreditAnalyticsParams & {
  source?: Exclude<OpenCreditPackModalLocations, 'checkout'>;
};

export const useTrackCreditPackCancellationInitiated = () => {
  const { track } = useAnalyticsUtilities();

  const trackCreditPackCancellationInitiated = useCallback(
    (params: UseTrackCreditPackCancellationInitiatedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackCreditPackCancellationInitiated };
};
